export const GET_CHAT_REQUESTED = 'GET_CHAT_REQUESTED'
export const GET_CHAT_SUCCESS = 'GET_CHAT_SUCCESS'
export const GET_CHAT_FAILURE = 'GET_CHAT_FAILURE'

export const ColorScheme = {
  customerColor: '#7A7A7A',
  customerColorTinted: '#C7C7C7',
  selectedAgentColor: '#0277BE',
  selectedAgentColorTinted: '#97C6E2',
  agent_default_color: '#0F3261',                 // agent 4 onwards have same color
  agent_default_color_tinted: '#9FADC0',
  agent_colors: ['#4C5A17', '#15938C'],
  agent_colors_tinted: ['#B7BDA2', '#A1D4D1'],
}
